import { useCallback } from "react";
import usePlugins from "../usePlugins";
function useOverrides() {
    const plugins = usePlugins();
    return useCallback((editor) => {
        return plugins.reduce((prev, p) => p.override(editor, p.options), editor);
    }, [plugins]);
}
export default useOverrides;
